module.exports = __webpack_public_path__ + "img/thumbnail-cedrow-side-by-side.821f0ae4.webp";